
import { HabitsKeys } from '@/i18n/types';

export const habits: Record<HabitsKeys, string> = {
  habits: 'Hábitos',
  myHabits: 'Mis Hábitos',
  newHabit: 'Nuevo Hábito',
  editHabit: 'Editar Hábito',
  deleteHabit: 'Eliminar Hábito',
  habitName: 'Nombre del Hábito',
  habitDescription: 'Descripción del Hábito',
  frequency: 'Frecuencia',
  selectDays: 'Seleccionar Días',
  categories: 'Categorías',
  development: 'Desarrollo',
  health: 'Salud',
  productivity: 'Productividad',
  learning: 'Aprendizaje',
  lifestyle: 'Estilo de Vida',
  personalDevelopment: 'Desarrollo Personal',
  habitTracker: 'Seguimiento de Hábitos',
  habitsDesc: 'Crea hábitos positivos y sigue tu progreso.',
  suggestedHabits: 'Hábitos Sugeridos',
  suggestedHabitsDesc: 'Selecciona hábitos de esta lista que te gustaría agregar a tus hábitos.',
  addSelectedHabits: 'Agregar Hábitos Seleccionados',
  noHabitsSelected: 'No hay hábitos seleccionados',
  pleaseSelectHabits: 'Por favor selecciona al menos un hábito para agregar.',
  habitsAdded: 'Hábitos Agregados',
  multipleHabitsAdded: 'Los hábitos seleccionados han sido agregados a tu lista.',
  singleHabitAdded: 'El hábito seleccionado ha sido agregado a tu lista.',
  errorLoadingSuggested: 'Error al cargar los hábitos sugeridos',
  noSuggestedHabits: 'No hay hábitos sugeridos disponibles en este momento.',
  loading: 'Cargando',
  // New translations
  adminSuggestedHabits: 'Gestionar Hábitos Sugeridos',
  adminSuggestedHabitsDesc: 'Crea, edita o elimina hábitos sugeridos para los usuarios.',
  addSuggestedHabit: 'Añadir Hábito Sugerido',
  editSuggestedHabit: 'Editar Hábito Sugerido',
  enterHabitName: 'Ingresa el nombre del hábito',
  enterHabitDescription: 'Ingresa la descripción del hábito',
  selectCategory: 'Seleccionar categoría',
  selectFrequency: 'Seleccionar frecuencia',
  cancel: 'Cancelar',
  update: 'Actualizar',
  create: 'Crear',
  delete: 'Eliminar',
  category: 'Categoría',
  daily: 'Diario',
  weekly: 'Semanal',
  monthly: 'Mensual',
  confirmDelete: 'Confirmar Eliminación',
  deleteHabitConfirmation: '¿Estás seguro de que quieres eliminar este hábito sugerido? Esta acción no se puede deshacer.',
  habitUpdated: 'Hábito Actualizado',
  habitHasBeenUpdated: 'El hábito ha sido actualizado correctamente.',
  habitCreated: 'Hábito Creado',
  habitHasBeenCreated: 'El hábito ha sido creado correctamente.',
  error: 'Error',
  errorSavingHabit: 'Ha ocurrido un error al guardar el hábito.',
  habitDeleted: 'Hábito Eliminado',
  habitHasBeenDeleted: 'El hábito ha sido eliminado correctamente.',
  errorDeletingHabit: 'Ha ocurrido un error al eliminar el hábito.',
  suggestedHabitsFor: 'Hábitos Sugeridos para',
  addHabit: 'Añadir Hábito',
  noHabitsAvailable: 'No hay hábitos disponibles en este idioma todavía.',
  allLanguages: 'Mostrar Todos los Idiomas',
  currentLanguageOnly: 'Solo Idioma Actual',
  habitCalendar: 'Calendario',
  habitStats: 'Estadísticas',
  noHabitsYet: 'Aún no hay hábitos',
};
